import { QueryCache, QueryClient } from '@tanstack/react-query';
import { TRPCClientError } from '@trpc/client';

function isUnauthorized(error: unknown): boolean {
  if (!(error instanceof TRPCClientError)) return false;
  const data = error.data as { code?: string } | undefined;
  return data?.code === 'UNAUTHORIZED';
}

let redirecting = false;

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (!isUnauthorized(error) || redirecting) return;
      redirecting = true;
      window.location.assign('/login?reason=session-expired');
    },
  }),
  // networkMode 'always': the default 'online' mode pauses fetches on Chrome's
  // online/offline heuristic, which flaps under VPNs/port-forwards and leaves
  // queries stuck in fetchStatus 'paused' - an infinite spinner with no error.
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      networkMode: 'always',
    },
    mutations: {
      networkMode: 'always',
    },
  },
});
